import React, { useState } from 'react';
import {
  Button as Btn,
  ButtonProps,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonVariant } from '../Button';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import useMobile from '../../hooks/useMobileHook';

export type IconButtonVariant =
  | ButtonVariant
  | 'icon-default'
  | 'icon-alert'
  | 'icon-emphasized'
  | 'clear-selection'
  | 'clear-selection-white';

export type customIconButtonProps = ButtonProps &
  React.PropsWithChildren<{
    variant?: IconButtonVariant;
    icon?: IconProp;
    isStatusButton?: boolean;
    extLabel?: string;
    className?: string;
    link?: string;
    target?: string;
    tooltipText?: string;
    styleColor?: string;
  }>;

const IconButton = ({
  variant = 'primary',
  icon,
  isStatusButton,
  extLabel,
  className,
  onMouseDown,
  link,
  target,
  tooltipText,
  styleColor,
  ...props
}: customIconButtonProps) => {
  const [show, setShow] = useState(false);
  const isMobile = useMobile();
  const iconName = (iconName: IconProp) => <FontAwesomeIcon icon={iconName} />;

  const handleOnMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onMouseDown && onMouseDown(event);
  };

  const handleOnToggle = () => {
    setShow(!show);
  };

  const iconBtn = tooltipText ? (
    <OverlayTrigger
      show={show}
      trigger={isMobile ? 'click' : undefined}
      rootClose={isMobile ? true : undefined}
      placement="top"
      onToggle={handleOnToggle}
      overlay={<Tooltip>{tooltipText}</Tooltip>}
    >
      <a href={link} target={target} className={'d-block'}>
        <Btn
          variant={variant}
          {...props}
          onMouseDown={handleOnMouseDown}
          className={`btn-icon ${className ? className : ''}`}
        >
          {isStatusButton && (
            <span
              className={'indicator small-indicator failed-indicator'}
            ></span>
          )}
          {icon && <span>{iconName(icon)}</span>}
        </Btn>
      </a>
    </OverlayTrigger>
  ) : (
    <a href={link} target={target} className={'d-block'}>
      <Btn
        variant={variant}
        {...props}
        onMouseDown={handleOnMouseDown}
        className={`btn-icon ${className ? className : ''}`}
      >
        {isStatusButton && (
          <span className={'indicator small-indicator failed-indicator'}></span>
        )}
        {icon && <span>{iconName(icon)}</span>}
      </Btn>
    </a>
  );

  if (!extLabel) {
    return iconBtn;
  } else {
    return (
      <span className="d-flex align-items-center cursor-pointer">
        {iconBtn}
        <span className="icon-label" style={{ color: styleColor }}>{extLabel}</span>
      </span>
    );
  }
};

export default IconButton;
